import { DistributionEffects } from './distribution.effects';

export const effects: any[] = [DistributionEffects];

export * from './distribution.effects';
